<!-- Rules Screen has
        * introductory page  [no panel]
        * tutorial

    Rules view has
        * section on Pentelion rules  [panel has table of contents]
        * overview of all powers  [panel has navigation structure with domains]
 -->

<main>
	<LoginPanel />
	<section data-help="firststeps">
        <h1>Get started</h1>
        <h3 title="Das ist Sindarin für 'Sei gegrüßt'">Mae Govannen</h3>

        <p>Wilkommen auf der ofiziellen Website von Pentelion für digitales Rollenspiel.</p>
        <br/>

        <h3>Anmeldung:</h3>
        <p>Auf der linken Seite ist ein Feld, wo du dich Anmelden kannst. Dazu musst du nur deinen Anmeldenamen eingeben.<br>
        Damit die App deinen Namen erkennt, musst du den ersten Buchstaben groß schreiben, und den Rest klein.<br>
        Darunter sind auch noch Einstellungen, mit denen du das äuserliche Bild anpassen kannst.<br>
        Sobald du dich angemeldet hast, kannst du mit den Buttons/Tabs links oben die verschiedenen Seiten auswählen.</p>
        <br/>

        <h3>Home:</h3>
        <p>Ganz links in der Ecke oben findest du einen Home Button. Damit kommst du wieder auf die Anmeldungsseite.<br>
        Du bleibst allerdings angemeldet, sodass du einfach über die Tabs neben dem Button wieder zurück kannst.</p>
        <br/>

        <h3>Abenteuer:</h3>
        <p>Wenn du auf den Tab 'Abenteuer klickst, siehst du alle Abenteuer, bei denen du Spielleiter bist.<br>
        Du kannst ein Abenteuer auswählen, sodass du mehr Informationen darüber erhälst.<br>
        Daneben ist ein Knopf, mit dem du, wenn du der Spielleiter heute Abend bist, ein Abenteuer starten kannst, zu dem die anderen dann beitreten können.<br>
        Außerdem kannst dich schon vor dem Abend anmelden und die notwendigen Sachen für dein Abenteuer vorbereiten und eintragen, wie z.B. Karten oder Gegner.<br>
        Sobald jemand ein Abenteuer gestartet hat, erscheint dieser Knopf für andere nicht mehr, und du siehst bei den darstehenden Abenteuern das aktuelle, also das, das der Spielleiter gestartet hat.</p>
        <br/>

        <h3>Charaktere:</h3>
        <p>Neben den Abenteuern sind die Charaktere. Dort siehst du alle von dir jemals erstellten und noch aktiven.<br>
        Du kannst einen Charakter durch klicken auf sein Bild auswählen, sodass sich der Charakterbogen rechts davon öffnet, wo jetzt dieser TExt steht.<br>
        Dort siehst du alle Informationen über diesen Charakter, also seine Eigenschaften, Fähigkeiten und Kräfte.<br>
        Wenn du den Charakterbogen wieder schließsen willst, musst du einfach nochmal auf das Bild klicken.<br>
        Der Charakter,den du in dem aktuell laufendem Spiel haben wirst, ist durch ...(keine Ahnung) hervorgehoben.</p>
        <br/>

        <h3>Wichtig:</h3>
        <p>Wenn du dich anmeldest und ein Abenteuer gerade läuft, trittst du sofort diesem Abenteure bei.<br>
        #wenn du diesen Text lesen kannst, hat der Spielleiter das Abenteuer noch nicht gestartet, was er aber jeder Zeit machen kann.<br>
        Sobald er dies getan hat, trittst du diesem auch automatisch bei.</p>
        <br/>

        <h3 title="Das ist Sindarin für 'gutes Spiel' (wörtlich'Spiel gut')">Teilien Vain</h3>
        <br>
        <br>
        <br>
        <br>


        <p class="Info"><b>Mae Govannen: </b>Dies ist eine klassische Begrüßung bei den Elben auf Sindarin.<br>
        Dieser Satz setzt sich aus den Wörtern 'mae' und 'govannen' zusammen.<br>
        'mae' ist ein Adverb und heißt 'gut'.<br>
        'govannen' ist ein Verb und bedeutet 'begegnet'.<br>
        Wörtlich würde die Übersetzung also 'gut begegnet' (emglisch: 'well met') heißen</p>
        <p class="Info"><b>Teilien Vain: </b>Das ist ein zusammengewürfelter Satz (er ist deshalb wahrschienlich nicht grammatikalisch richtig), der Gutes Spiel heißen soll.<br>
        Er besteht aus den Sindarinwörtern 'Teilien' und 'bain'.<br>
        'Teilien' heißt 'Spiel'<br>
        'bain' ist ein Adjektiv und bedeutet 'gut'. Adjektive stehen meistens hinter dem Nomen, auf das es sich bezieht.<br>
        Auserdem wird es mutiert, das heißt, dass aus dem 'b' am Anfang ein 'v' wird.</p>
	</section>


</main>


<script>
    import LoginPanel from "../panels/LoginPanel.svelte";
</script>


<style>
    main {
        width: 100%;
        height: 100vh;
        overflow: auto;
	}
</style>